<template>
<div>
<MainToolbar v-bind:notif="notif" v-bind:objDialog="objDialog"></MainToolbar>
<transition name="router-anim" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutDown">
  <v-content>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex md8 xs12>
          <v-btn color="green white--text" v-if="IsAccessCreateAgent" @click.native="addAgent">Add New</v-btn>
          <v-btn color="green white--text" v-if="IsAccessSetLogTypes" @click.native="setLogTypes()">Set Log Types</v-btn>
          <v-btn color="green white--text" v-if="IsAccessAgentSync" @click.native="addAgentFromGateway">Sync With Gateway</v-btn>
          <v-btn color="green white--text" v-if="IsAccessRefreshAgent" @click.native="RefreshAllAgents">Refresh All Agents</v-btn>
        </v-flex>
        <v-flex md4 xs12>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-flex>
      </v-layout>
      <v-progress-linear :indeterminate="true" height="5" color="green" v-if="actioninProgress"></v-progress-linear>
      <v-data-table v-model="selected"
          :headers="headers"
          :items="agents"
          :pagination.sync="pagination"
          :search="search"
          :rows-per-page-items=[10,20,35]
          :custom-sort="customSort"
          class="elevation-1">
          <template slot="headers" slot-scope="props">
            <tr>
              <!-- <th>
                <v-checkbox
                  :input-value="props.all"
                  :indeterminate="props.indeterminate"
                  primary
                  hide-details
                  @click.native="toggleAll"
                ></v-checkbox>
              </th> -->
              <th v-for="header in props.headers"
                  :key="header.text"
                  :class="['column', header.sortable == false ? '' : 'sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.visibility]"
                  @click="header.sortable != false && changeSort(header.value)">
                  <v-icon small v-show="header.sortable != false">arrow_upward</v-icon>
                  {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <!-- <td>
                <v-checkbox
                  :input-value="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
            </td>     -->
            <td class="text-xs-center hidden-xs-only">{{ props.item.DisplayName }}</td>
            <td class="text-xs-center">{{ props.item.IsAutoUpdateAvailable }}</td>
            <td class="text-xs-center">{{ props.item.IsLive }}</td>
            <td class="text-xs-center hidden-xs-only">{{ props.item.AgentType }}</td>
            <td class="text-xs-center hidden-xs-only">{{ props.item.AgentVersion }}</td>
            <td class="text-xs-center hidden-xs-only">{{ props.item.AgrisVersion }}</td>
            <td class="text-xs-center hidden-xs-only">{{ formatDate(props.item.LastInfoSynced) }}</td>
            <td class="text-xs-center hidden-xs-only">{{ getServerName(props.item.InfoJSON) }}</td>
            <td class="justify-center layout px-0" v-if="IsAccessEditAgent || IsAccessRefreshAgent || IsAccessViewDetail || IsAccessSetLogTypes">
              <v-btn v-if="IsAccessEditAgent" fab small dark color="green" class="white--text" @click="editAgent(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn v-if="IsAccessRefreshAgent && !props.item.State" fab small dark color="green" class="white--text" @click="syncAgent(props.item)">
                <v-icon>sync</v-icon>
              </v-btn>
              <v-btn v-if="IsAccessViewDetail" fab small dark color="green" class="white--text" @click="agentDetails(props.item)">
                  <v-icon>description</v-icon>
              </v-btn>
              <v-btn v-if="IsAccessSetLogTypes" fab small dark color="green" class="white--text" @click="setLogTypes(props.item)">
                  <v-icon>dns</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">
            Sorry, nothing to display here.
          </template>
          Your search for "{{ search }}" found no results.
      </v-data-table>
      <v-progress-linear :indeterminate="true" height="5" color="green" v-if="loading"></v-progress-linear>
      <v-dialog v-model="dialog" max-width="700px">
          <v-card>
              <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                 <v-form ref="agentForm" v-model="validateAgentForm" lazy-validation>
                   <v-layout row wrap>
                     <v-flex xs12 sm6>
                        <v-text-field label="Name" v-model="editedItem.Name" prepend-icon="edit" required :rules="[v => !!v || 'Name is required']"></v-text-field>
                     </v-flex>
                     <v-flex xs12 sm6>
                        <v-text-field label="Display Name" v-model="editedItem.DisplayName" prepend-icon="edit" required :rules="[v => !!v || 'Display Name is required']"></v-text-field>
                     </v-flex>
                     <v-flex xs12 sm6>
                        <v-text-field label="Email" v-model="editedItem.Email" prepend-icon="edit" required :rules="[v => !!v || 'Email is required']"></v-text-field>
                     </v-flex>
                     <v-flex xs12 sm6>
                        <v-text-field label="Password" v-model="editedItem.Password" prepend-icon="lock" required :rules="[v => !!v || 'Password is required']"></v-text-field>
                     </v-flex>
                     <v-flex xs12 sm6>
                        <v-text-field :label="getLabel('Link_1') + ' Monitor Link'" v-model="editedItem.MonitorLinkJson.Link_1" prepend-icon="language"></v-text-field>
                     </v-flex>
                     <v-flex xs12 sm6>
                        <v-text-field :label="getLabel('Link_2') + ' Monitor Link'" v-model="editedItem.MonitorLinkJson.Link_2" prepend-icon="language"></v-text-field>
                     </v-flex>
                     <v-flex xs12 sm6>
                        <v-text-field label="Auto-Update Name" v-model="editedItem.AutoUpdateName" prepend-icon="edit" required :rules="[v => !!v || 'Auto-Update Name is required']"></v-text-field>
                     </v-flex>
                     <v-flex xs12 sm6>
                        <v-switch :label="`Is Live Client: ${!!editedItem.IsLive}`" v-model="editedItem.IsLive" color="green"></v-switch>
                     </v-flex>
                   </v-layout>
                 </v-form>
              </v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                          <v-btn outline color="green darken-2" @click.native="done()">Done <v-icon right dark>check_circle</v-icon></v-btn>
                          <v-btn outline color="green darken-2" @click.native="close">Cancel</v-btn>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                          <v-progress-linear :indeterminate="true" height="5" color="green" v-if="actioninProgress"></v-progress-linear>
                      </v-flex>
                  </v-layout>
              </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDetails" max-width="1000px">
          <v-card>
              <v-card-title>
                  <span class="headline">{{ editedItem.DisplayName }}</span>
              </v-card-title>
              <v-card-text>
                  <v-container grid-list-md>
                      <v-layout wrap>
                          <v-btn outline color="green darken-2" v-if="IsAccessOpenMonitor && editedItem.MonitorLinkJson.Link_1"  @click.native="openMonitor(editedItem.MonitorLinkJson.Link_1)">Open {{getLabel('Link_1')}} Monitor<v-icon right dark>dashboard</v-icon></v-btn>
                          <v-btn outline color="green darken-2" v-if="IsAccessOpenMonitor && editedItem.MonitorLinkJson.Link_2"  @click.native="openMonitor(editedItem.MonitorLinkJson.Link_2)">Open {{getLabel('Link_2')}} Monitor<v-icon right dark>dashboard</v-icon></v-btn>
                          <v-btn outline color="green darken-2" v-if="IsAccessRefreshAgent && !editedItem.State" @click.native="syncAgent(editedItem)">Refresh <v-icon right dark>refresh</v-icon></v-btn>
                          <v-btn outline color="green darken-2" v-if="IsAccessSetupAutoUpdate && !editedItem.IsAutoUpdateAvailable" @click.native="setupAgentAutoUpdate(editedItem)">Setup AutoUpdate <v-icon right dark>device_hub</v-icon></v-btn>
                          <v-btn outline color="green darken-2" v-if="IsAccessUpdateAgent && editedItem.IsAutoUpdateAvailable && !editedItem.State" @click.native="AgentAutoUpdate(editedItem)">Update Agent<v-icon right dark>eject</v-icon></v-btn>
                          <v-btn outline color="green darken-2" v-if="IsAccessRestartAgent" @click.native="ForceRestartAgent(editedItem)">Restart Agent<v-icon right dark>power_settings_new</v-icon></v-btn>
                          <v-btn outline color="green darken-2" v-if="IsAccessDeveloperPanel && editedItem.IsAutoUpdateAvailable && !editedItem.State"  @click.native="DeveloperPanel(editedItem)">Developer Panel<v-icon right dark>developer_board</v-icon></v-btn>
                          <v-btn outline color="green darken-2" v-if="IsAccessCheckStausOL" @click.native="CheckOnlineStatus">Check Online Status<v-icon v-if="editedItem.IsOnline===true" right dark>done_all</v-icon><v-icon right dark  v-if="editedItem.IsOnline===false">block</v-icon><v-icon right dark  v-if="editedItem.IsOnline===null">warning</v-icon></v-btn>
                          <v-btn outline color="green darken-2" @click.native="closeDetails">Cancel</v-btn>
                      </v-layout>
                      <p v-if="editedItem.State"><b>Some actions on this agent may be disabled as it is in update mode with State:{{ editedItem.State }}</b></p>
                      <v-layout wrap v-if="editedItem.InfoJSON">
                          <v-flex xs12 sm6 md6>
                              <span class="grey--text">Service Name</span><br>
                              <span class="grey--text">Is AutoUpdate Available</span><br>
                              <span class="grey--text">Last Synced</span><br>
                              <span class="grey--text">Agent Version</span><br>
                              <span class="grey--text">Agent Machine</span><br>
                              <span class="grey--text">Agent SessionId</span><br>
                              <span class="grey--text">Is Online</span><br>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                              <span class="grey--text">{{ editedItem.InfoJSON.ServiceName }}</span><br>
                              <span class="grey--text">{{ editedItem.IsAutoUpdateAvailable }}</span><br>
                              <span class="grey--text">{{formatDate3(editedItem.LastInfoSynced)}}</span><br>
                              <span class="grey--text">{{editedItem.AgentVersion}}</span><br>
                              <span class="grey--text">{{ getServerName(editedItem.InfoJSON) }}</span><br>
                              <span class="grey--text">{{editedItem.SessionId}}</span><br>
                              <span class="grey--text">{{editedItem.IsOnline===true?'Online':(editedItem.IsOnline===false?'Offline':(editedItem.IsOnline===null?'Agent Name Not Found':'Unknown'))}}</span><br>
                          </v-flex>
                      </v-layout>
                      <v-list two-line v-if="!editedItem.State" >
                        <!-- v-if="!approvingRelease"  -->
                          <template v-for="(item) in availableReleases">
                              <v-list-tile :key="item.AgentVersion" avatar ripple @click="ReleaseSelected(item)">
                                  <v-list-tile-avatar>
                                      <v-icon large v-if="selectedRelease!==item" color="black darken-2">archive</v-icon>
                                      <v-icon large v-else color="green darken-2">archive</v-icon>
                                  </v-list-tile-avatar>
                                  <v-list-tile-content>
                                      <v-list-tile-title>{{ item.AgentVersion }}</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ new Date(item.CreationTime).toLocaleString()}}</v-list-tile-sub-title>
                                  </v-list-tile-content>
                                  <v-list-tile-action v-if="selectedRelease==item">
                                      <v-list-tile-action-text>Are You Sure?</v-list-tile-action-text>
                                      <v-icon  @click.native="confirmUpdate()" color="green darken-2">check_circle</v-icon>
                                  </v-list-tile-action>
                              </v-list-tile>
                          </template>
                      </v-list>
                      <v-layout wrap v-if="editedItem.InfoJSON.Files.length && selectedRelease==null && !availableReleases.length">
                          <v-data-table v-model="selected"
                                        :headers="filesHeaders"
                                        :items="editedItem.InfoJSON.Files"
                                        :pagination.sync="paginationFile"
                                        :search="search"
                                        :rows-per-page-items=[10,20,35]
                                        class="elevation-1">
                              <template slot="headers" slot-scope="props">
                                  <tr>
                                      <th v-for="header in props.headers"
                                          :key="header.text"
                                          :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.visibility]"
                                          @click="changeSortFile(header.value)">
                                          <v-icon small>arrow_upward</v-icon>
                                          {{ header.text }}
                                      </th>
                                  </tr>
                              </template>
                              <template slot="items" slot-scope="props">
                                  <td class="text-xs-center hidden-xs-only">{{ props.item.ProductName }}</td>
                                  <td class="text-xs-center">{{ props.item.Name }}</td>
                                  <td class="text-xs-center hidden-xs-only">{{ props.item.ProductVersion }}</td>
                                  <td class="text-xs-center hidden-xs-only">{{ props.item.FileVersion }}</td>
                                  <td class="text-xs-center hidden-xs-only">{{ formatDate2(props.item.CreationTime) }}</td>
                                  <td class="text-xs-center hidden-xs-only">{{ formatDate2(props.item.LastWriteTime) }}</td>
                                  <td class="justify-center layout px-0" v-if="IsAccessDownloadFile">
                                      <v-btn fab small dark color="green" class="white--text" @click="getFile(props.item.FilePath, props.item.Name)">
                                          <v-icon>get_app</v-icon>
                                      </v-btn>
                                  </td>
                              </template>
                              <template slot="no-data"> Sorry, nothing to display here. </template>
                              Your search for "{{ search }}" found no results.
                          </v-data-table>
                      </v-layout>
                  </v-container>
              </v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                          <v-btn outline color="green darken-2" @click.native="closeDetails">Cancel</v-btn>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                          <v-progress-linear :indeterminate="true" height="5" color="green" v-if="actioninProgress"></v-progress-linear>
                      </v-flex>
                  </v-layout>
              </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLogTypes" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{objLogInfo.Title}}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="logTypesForm" v-model="validateLogTypesForm" lazy-validation>
              <v-layout row wrap>
                <p class="caption" style="color:red;">
                  Note: <br/>
                  {{
                    objLogInfo.Title === 'ALL AGENTS'?
                    'Save will replace all agents log type(s) data and if you not select any type then all the type(s) will be marked as unassigned against all agents' :
                    'If you save without select any type then type(s) will be marked as unassigned'
                  }}

                </p>
                <v-flex xs12>
                  <v-select
                    label="Log Types" multiple chips
                    prepend-icon="dns"
                    item-text="ConfigurationKey"
                    v-model="objLogInfo.LogTypes"
                    return-object
                    :items="configKeys"></v-select>
                </v-flex>
                <v-flex xs12 v-show="objLogInfo.Title !== 'ALL AGENTS' && aliveIntervalKeyId > 0">
                   <v-checkbox
                   color="primary"
                    v-model="objLogInfo.AliveIntervalChecked"
                    label="Set Alive Interval Check On Agris"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 v-show="objLogInfo.Title !== 'ALL AGENTS' && aliveIntervalKeyId > 0 && objLogInfo.AliveIntervalChecked">
                    <v-text-field
                      label="Alive Interval Check After (in minute)"
                      v-model="objLogInfo.AgrisServiceAliveIntervalCheck"
                      prepend-icon="edit"
                      type="number"
                      required :rules="[
                        v => {
                          const reg = /^\d+$/;
                          if (!v && !this.objLogInfo.AliveIntervalChecked) return true;
                          if (!reg.test(v)) return 'Whole number is required';
                          if (String(v).length > 5) return 'Only 5 digit is allowed';
                          return true;
                        }
                      ]"
                    ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outline color="green darken-2" @click.native="saveLogType" :disabled="btnDisabled">Save <v-icon right dark>check_circle</v-icon></v-btn>
              <v-btn outline color="green darken-2" @click.native="closeLogTypes">Cancel</v-btn>
          </v-card-actions>
          <v-layout wrap>
            <v-flex xs12>
                <v-progress-linear :indeterminate="true" height="5" color="green" v-if="actioninProgress"></v-progress-linear>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-container>
    <a hidden id="ancherDownload" :href="downloadFileLink" :download="downloadFileName"></a>
  </v-content>
</transition>
</div>
</template>
<script>
import DataService from '@/services/data-service';
import moment from 'moment';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import MainToolbar from '@/components/MainToolbar.vue';
import { ModuleConfigurationRequest } from '../Types/ModuleConfigurationRequest';

const dataService = new DataService();

export default {
  name: 'controlboard',
  props: [],
  components: {
    MainToolbar,
  },
  data: () => ({
    errors: [],
    dialog: false,
    dialogDetails: false,
    dialogLogTypes: false,
    notif: {
      color: 'success',
      message: '',
      show: false,
    },
    objDialog: {
      dialog_title: '',
      dialog_body: '',
      btn_ok_text: 'Ok',
      btn_cancel_text: 'Cancel',
      show: false,
      result: undefined,
    },
    validateAgentForm: false,
    validateLogTypesForm: false,
    dialogDetailsAction: null,
    loading: false,
    actioninProgress: false,
    btnDisabled: false,
    editedIndex: -1,
    downloadFileName: '',
    downloadFileLink: '',
    aliveIntervalKeyId: 0,

    editedItem: {
      TicketNumber: '0000123',
      AccountName: 'A Growsem',
      AccountDescription: 'William Growsem',
      ShipToFromNameDescription: 'Adam Growsem',
      TicketLocation: 'Central Depot',
      NetWeight: '56,000.00 LB',
      NetQuantity: '76,000.00 LB',
      CommodityDescription: '01- Yellow Corn',
      RequestUser: '',
      ReviewRequestId: '',
      DeclineComments: '',
      IsLive: false,
      InfoJSON: {
        Files: [],
        Settings: {},
        Agris: {},
      },
      MonitorLinkJson: {
        Link_1: '',
        Link_2: '',
      },
    },
    defaultItem: {
      TicketNumber: '0000123',
      AccountName: 'A Growsem',
      AccountDescription: 'William Growsem',
      ShipToFromNameDescription: 'Adam Growsem',
      TicketLocation: 'Central Depot',
      NetWeight: '56,000.00 LB',
      NetQuantity: '76,000.00 LB',
      CommodityDescription: '01- Yellow Corn',
      RequestUser: '',
      ReviewRequestId: '',
      DeclineComments: '',
      IsLive: false,
      InfoJSON: {
        Files: [],
        Settings: {},
        Agris: {},
      },
      MonitorLinkJson: {
        Link_1: '',
        Link_2: '',
      },
    },
    objLogInfo: {
      Title: '',
      SOGEAgentId: '',
      LogTypes: [],
      AliveIntervalChecked: false,
      AgrisServiceAliveIntervalCheck: '',
    },
    search: '',
    pagination: {
      sortBy: 'DisplayName',
    },
    paginationFile: {
      sortBy: 'Name',
    },
    logModule: {},
    intervalModule: {},
    selected: [],
    filesHeaders: [],
    headers: [],
    agents: [],
    availableReleases: [],
    configModules: [],
    configKeys: [],
    logConfigs: [],
    intervalConfigs: [],

    selectedRelease: null,
    autoRefreshInterval: null,
    AgrisVersion: null,
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Actions';
    },
    IsAccessCreateAgent() {
      return this.$store.getters.IsValidCode('AH2CA0905');
    },
    IsAccessEditAgent() {
      return this.$store.getters.IsValidCode('AH2EA0712');
    },
    IsAccessRefreshAgent() {
      return this.$store.getters.IsValidCode('AH2RA0210');
    },
    IsAccessViewDetail() {
      return this.$store.getters.IsValidCode('AH2DA0004');
    },
    IsAccessSetLogTypes() {
      return this.$store.getters.IsValidCode('AH2SL0503') && this.configKeys && this.configKeys.length > 0;
    },
    IsAccessRestartAgent() {
      return this.$store.getters.IsValidCode('AH2RA1308');
    },
    IsAccessCheckStausOL() {
      return this.$store.getters.IsValidCode('AH2CO0702');
    },
    IsAccessSetupAutoUpdate() {
      return this.$store.getters.IsValidCode('AH2SA0510');
    },
    IsAccessUpdateAgent() {
      return this.$store.getters.IsValidCode('AH2UA1208');
    },
    IsAccessDownloadFile() {
      return this.$store.getters.IsValidCode('AH2DF0206');
    },
    IsAccessOpenMonitor() {
      return this.$store.getters.IsValidCode('AH2OM0808');
    },
    IsAccessAgentSync() {
      return this.$store.getters.IsValidCode('AH2SG1103');
    },
    IsAccessDeveloperPanel() {
      return this.$store.getters.IsValidCode('AH1DP1302');
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
    $route(to, from) {
      console.log(to.params.id);
      this.initialize();
    },
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    next();
  },

  created() {
    this.getDataFromServer();
    this.loadLogTypes();
    this.filesHeaders = [
      {
        text: 'Product Name',
        value: 'ProductName',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      }, {
        text: 'Name',
        value: 'Name',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'Product Version',
        value: 'ProductVersion',
        align: 'left',
        width: '1%',
      },
      {
        text: 'File Version',
        value: 'FileVersion',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'Creation Time',
        value: 'CreationTime',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'Last Modified',
        value: 'LastWriteTime',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
    ];
    this.headers = [

      {
        text: 'Agent',
        value: 'DisplayName',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'AutoUpdate Enabled',
        value: 'IsAutoUpdateAvailable',
        align: 'left',
        width: '1%',
      },
      {
        text: 'Is Live on Client',
        value: 'IsLive',
        align: 'left',
        width: '1%',
      },
      {
        text: 'Type',
        value: 'AgentType',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'Agent Version',
        value: 'AgentVersion',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'System Version',
        value: 'AgrisVersion',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'Last Verified Date',
        value: 'LastInfoSynced',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'Server Name',
        value: 'Server Name',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
    ];
    if (this.IsAccessDownloadFile) {
      this.filesHeaders.push({
        text: 'Actions',
        align: 'left',
        width: '1%',
        sortable: false,
      });
    }
    if (this.IsAccessEditAgent || this.IsAccessRefreshAgent || this.IsAccessViewDetail || this.IsAccessSetLogTypes) {
      this.headers.push({
        text: 'Actions',
        align: 'left',
        width: '1%',
        sortable: false,
      });
    }
  },
  methods: {
    showNotif(obj) {
      const that = this;
      that.notif.show = true;
      that.notif.message = obj.message;
      that.notif.color = obj.color;
    },
    getLabel(prop) {
      const obj = this.$store.getters.getLinkLabels;
      return obj[prop];
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.desserts.slice();
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        let sortA;
        let sortB;
        if (index === 'Server Name') {
          sortA = this.getServerName(a.InfoJSON);
          sortB = this.getServerName(b.InfoJSON);
        } else {
          sortA = a[index];
          sortB = b[index];
        }
        if (isDesc) {
          if (sortA < sortB) return 1;
          if (sortA > sortB) return -1;
          return 0;
        }
        if (sortA < sortB) return -1;
        if (sortA > sortB) return 1;
        return 0;
      });
      return items;
    },
    RefreshAllAgents() {
      if (!this.IsAccessRefreshAgent) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.actioninProgress = true;
      // item.AgentId
      dataService.RefreshAllAgents().then(() => {
        this.getDataFromServer().then(() => {
          this.actioninProgress = false;
        });
      });
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    changeSortFile(column) {
      if (this.paginationFile.sortBy === column) {
        this.paginationFile.descending = !this.paginationFile.descending;
      } else {
        this.paginationFile.sortBy = column;
        this.paginationFile.descending = false;
      }
    },
    addAgent() {
      if (!this.IsAccessCreateAgent) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.editedIndex=-1;
      this.editedItem={
        MonitorLinkJson: {
          Link_1: '',
          Link_2: '',
        },
        Email: '',
        AutoUpdateName: '',
        Password: '',
        InfoJSON: {
          Files: [],
          Settings: {},
          Agris: {},
        },
      };
      this.$refs.agentForm.resetValidation();
      this.dialog = true;
    },
    addAgentFromGateway() {
      if (!this.IsAccessAgentSync) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.actioninProgress = true;
      dataService.SyncAgentsWithGateway().then(() => {
        this.getDataFromServer().then(() => {
          this.actioninProgress = false;
          this.showNotif({ color: 'success', message: 'Synced' });
        });
      }).catch(() => {
        this.actioninProgress = false;
      });
    },
    editAgent(item) {
      if (!this.IsAccessEditAgent) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.editedIndex = this.agents.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.MonitorLinkJson = Object.assign({ Link_1: '', Link_2: '' }, JSON.parse(item.MonitorLink));
      this.$refs.agentForm.resetValidation();
      this.dialog = true;
    },
    agentDetails(item) {
      if (!this.IsAccessViewDetail) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.dialogDetails=true;
      this.availableReleases=[];
      this.selectedRelease=null;
      this.editedItem=item;
      this.editedItem.MonitorLinkJson = Object.assign({ Link_1: '', Link_2: '' }, JSON.parse(item.MonitorLink));
    },
    setLogTypes(item) {
      if (!this.IsAccessSetLogTypes) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.$refs.logTypesForm.resetValidation();
      if (item) {
        this.objLogInfo.Title = item.DisplayName;
        this.objLogInfo.SOGEAgentId = item.SOGEAgentId;
        this.objLogInfo.LogTypes = this.configKeys.filter(x =>
          this.logConfigs.findIndex(l =>
            String(l.Agent).toUpperCase() === String(item.SOGEAgentId).toUpperCase() &&
                l.ConfigurationKeyId === x.ConfigurationKeyId &&
                !!+l.ConfigurationValue) !== -1);
        const aliveIntervalObj = this.intervalConfigs.find(i =>
          i.ConfigurationKeyId === this.aliveIntervalKeyId &&
          String(i.Agent).toUpperCase() === String(item.SOGEAgentId).toUpperCase());
        if (aliveIntervalObj) {
          this.objLogInfo.AliveIntervalChecked = +aliveIntervalObj.ConfigurationValue > 0;
          this.objLogInfo.AgrisServiceAliveIntervalCheck = +aliveIntervalObj.ConfigurationValue > 0 ? aliveIntervalObj.ConfigurationValue : '5';
        } else if (this.aliveIntervalKeyId > 0) {
          this.objLogInfo.AliveIntervalChecked = false;
          this.objLogInfo.AgrisServiceAliveIntervalCheck = '5';
        }
      } else {
        this.objLogInfo.Title = 'ALL AGENTS';
        this.objLogInfo.SOGEAgentId = '';
        this.objLogInfo.LogTypes = [];
      }
      this.btnDisabled = false;
      this.dialogLogTypes = true;
    },
    saveLogType() {
      if (!this.$refs.logTypesForm.validate()) {
        return;
      }
      const postList = [];
      if (!this.configKeys || this.configKeys.length === 0) {
        this.showNotif({ color: 'info', message: 'Configuration does not have any log types' });
        return;
      }
      if (this.objLogInfo.SOGEAgentId && this.objLogInfo.SOGEAgentId.length > 0) {
        this.actioninProgress = true;
        this.btnDisabled = true;
        this.configKeys.forEach((k) => {
          const objLogConfig = this.logConfigs.find(l =>
            String(l.Agent).toUpperCase() === String(this.objLogInfo.SOGEAgentId).toUpperCase() &&
            l.ConfigurationKeyId === k.ConfigurationKeyId);
          const obj = new ModuleConfigurationRequest();
          obj.ConfigurationKeyId = k.ConfigurationKeyId;
          obj.ConfigurationId = objLogConfig ? objLogConfig.ConfigurationId : 0;
          obj.ConfigurationValue = this.objLogInfo.LogTypes &&
            this.objLogInfo.LogTypes.findIndex(l => l.ConfigurationKeyId === k.ConfigurationKeyId) !== -1 ?
            '1': '0';
          obj.Agent = String(this.objLogInfo.SOGEAgentId).toUpperCase();
          obj.Dataset = null;
          postList.push(obj);
        });
        const aliveIntervalObj = this.intervalConfigs.find(i =>
          i.ConfigurationKeyId === this.aliveIntervalKeyId &&
          String(i.Agent).toUpperCase() === String(this.objLogInfo.SOGEAgentId).toUpperCase());
        if (this.aliveIntervalKeyId > 0) {
          const obj = new ModuleConfigurationRequest();
          obj.ConfigurationKeyId = this.aliveIntervalKeyId;
          obj.ConfigurationId = aliveIntervalObj ? aliveIntervalObj.ConfigurationId : 0;
          obj.ConfigurationValue = this.objLogInfo.AliveIntervalChecked ? this.objLogInfo.AgrisServiceAliveIntervalCheck : '0';
          obj.Agent = String(this.objLogInfo.SOGEAgentId).toUpperCase();
          obj.Dataset = null;
          postList.push(obj);
        }
        dataService.postModuleConfigs(postList).then((resp) => {
          this.showNotif({ color: 'success', message: 'Config save successfully' });
          this.closeLogTypes();
          const that = this;
          let respCount = 0;
          // eslint-disable-next-line
          const respFunc = function () {
            respCount += 1;
            if (respCount === 2) {
              that.actioninProgress = false;
              that.btnDisabled = false;
            }
          };
          if (this.aliveIntervalKeyId > 0) {
            dataService.getModuleConfigs(this.intervalModule.ModuleId).then((configs) => {
              this.intervalConfigs = configs || [];
              respFunc();
            }).catch(err => respFunc());
          } else respFunc();
          if (this.logModule && this.logModule.ModuleId > 0) {
            dataService.getModuleConfigs(this.logModule.ModuleId).then((configs) => {
              this.logConfigs = configs || [];
              respFunc();
            }).catch(err => respFunc());
          } else respFunc();
        }).catch((err) => {
          this.actioninProgress = false;
          this.btnDisabled = false;
          this.showNotif({ color: 'error', message: 'Something went wrong' });
        });
      } else if (this.objLogInfo.Title === 'ALL AGENTS') {
        if (!this.agents || this.agents.length === 0) {
          this.showNotif({ color: 'info', message: 'Please fetch agent(s) first' });
          return;
        }
        this.actioninProgress = true;
        this.btnDisabled = true;
        this.agents.forEach((a) => {
          this.configKeys.forEach((k) => {
            const objLogConfig = this.logConfigs.find(l =>
              String(l.Agent).toUpperCase() === String(a.SOGEAgentId).toUpperCase() &&
              l.ConfigurationKeyId === k.ConfigurationKeyId);
            const obj = new ModuleConfigurationRequest();
            obj.ConfigurationKeyId = k.ConfigurationKeyId;
            obj.ConfigurationId = objLogConfig ? objLogConfig.ConfigurationId : 0;
            obj.ConfigurationValue = this.objLogInfo.LogTypes &&
              this.objLogInfo.LogTypes.findIndex(l => l.ConfigurationKeyId === k.ConfigurationKeyId) !== -1 ?
              '1': '0';
            obj.Agent = String(a.SOGEAgentId).toUpperCase();
            obj.Dataset = null;
            postList.push(obj);
          });
        });
        dataService.postModuleConfigs(postList).then((resp) => {
          this.showNotif({ color: 'success', message: 'Log types save successfully' });
          this.closeLogTypes();
          if (this.logModule && this.logModule.ModuleId > 0) {
            dataService.getModuleConfigs(this.logModule.ModuleId).then((configs) => {
              this.logConfigs = configs || [];
              this.actioninProgress = false;
              this.btnDisabled = false;
            });
          } else {
            this.actioninProgress = false;
            this.btnDisabled = false;
          }
        }).catch((err) => {
          this.actioninProgress = false;
          this.btnDisabled = false;
          this.showNotif({ color: 'error', message: 'Something went wrong' });
        });
      }
    },
    getFile(filePath, fileName) {
      if (!this.IsAccessDownloadFile) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.actioninProgress = true;
      this.downloadFileName = fileName;
      dataService.getFile(this.editedItem.SessionId, filePath, this.downloadFileName)
        .then((blobby) => {
          this.downloadFileLink = window.URL.createObjectURL(blobby);
          document.getElementById('ancherDownload').click();
          // const anchor = document.createElement('a');
          // document.body.appendChild(anchor);
          // anchor.href = downloadFileLink;
          // anchor.download = downloadFileName;
          // anchor.click();
          // document.body.removeChild(anchor);
          this.actioninProgress = false;
        })
        .catch((error) => {
          this.actioninProgress = false;
        });
    },
    AgentAutoUpdate(item) {
      if (!this.IsAccessUpdateAgent) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.actioninProgress = true;
      this.availableReleases=[];
      this.selectedRelease=null;
      dataService.getReleases().then((releases) => {
        console.log(item, releases, this);
        const possibleVersions = [];
        if (item.AgrisVersion) {
          possibleVersions.push(item.AgrisVersion);
        }
        if (item.AgentVersion) {
          possibleVersions.push((item.AgentVersion.split('.').slice(0, 2||item.AgentVersion.split('.').length).join('.')));
        }
        const agrisVersion =possibleVersions.sort((a, b) => this.sortVersion(a, b))[0]||'0.0';
        this.availableReleases=releases.filter(f => f.AgentType===item.AgentType && (this.compareVersion(f.AgrisVersion, agrisVersion) ||item.AgentType.toLocaleLowerCase()==='cinch') && this.editedItem.IsLive===f.IsProduction);

        this.availableReleases=this.availableReleases.sort((a, b) => this.sortVersion(a.AgrisVersion, b.AgrisVersion));
        this.actioninProgress = false;
      });
    },
    sortVersion(a, b) {
      const aSplit = a.split('.');
      const bSplit = b.split('.');
      const length = Math.min(aSplit.length, bSplit.length);
      // eslint-disable-next-line
      for (let i = 0; i < length; ++i) {
        if (parseInt(aSplit[i], 10) < parseInt(bSplit[i], 10)) {
          return -1;
        } else if (parseInt(aSplit[i], 10) > parseInt(bSplit[i], 10)) {
          return 1;
        }
      }
      if (aSplit.length < bSplit.length) {
        return -1;
      } else if (aSplit.length > bSplit.length) {
        return 1;
      }
      return 0;
    },
    compareVersion(v1, v2) {
      const comparator='>=';
      const v1parts = v1.split('.');
      const v2parts = v2.split('.');
      const maxLen = Math.max(v1parts.length, v2parts.length);
      let part1;
      let part2;
      let cmp = 0;
      for (let i = 0; i < maxLen && !cmp; i+=1) {
        part1 = parseInt(v1parts[i], 10) || 0;
        part2 = parseInt(v2parts[i], 10) || 0;
        if (part1 < part2) { cmp = 1; }
        if (part1 > part2) { cmp = -1; }
      }
      // eslint-disable-next-line
      return eval(`0${comparator}${cmp}`);
    },
    ForceRestartAgent(item) {
      if (!this.IsAccessRestartAgent) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.actioninProgress = true;
      dataService.ForceRestartAgent(item.AgentId).then(() => {
        this.actioninProgress = false;
      });
    },
    DeveloperPanel(item) {
      if (!this.IsAccessDeveloperPanel) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.$router.replace(`/developerboard/${item.AgentId}`);
    },
    setupAgentAutoUpdate(item) {
      if (!this.IsAccessSetupAutoUpdate) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.actioninProgress = true;
      dataService.CanAgentSetup(item.AgentId).then((errors) => {
        if (errors.length===0) {
          dataService.SetupAgentAutoUpdate(item.AgentId).then((_errors) => {
            if (_errors) {
              this.showNotif({ color: 'success', message: 'Success' });
            } else {
              this.showNotif({ color: 'error', message: 'Unable to setup.' });
            }
            this.actioninProgress = false;
            this.getDataFromServer();
          });
          setTimeout(() => {
            this.getDataFromServer();
          }, 1000);
        } else {
          this.actioninProgress = false;
          this.showNotif({ color: 'error', message: errors.toString() });
        }
      });
    },
    ReleaseSelected(release) {
      this.selectedRelease=release;
    },
    confirmUpdate() {
      this.actioninProgress = true;
      dataService.AutoUpdateAgent(this.editedItem.AgentId, this.selectedRelease).then((Updated) => {
        this.actioninProgress = false;
        this.showNotif({
          color: 'success',
          message: Updated.length===0?'Attempt Successfull. It takes few minutes to restart client agent, refresh agent after some time':Updated.toString(),
        });
        clearInterval(this.autoRefreshInterval);
        this.autoRefreshInterval=null;
        if (Updated.length===0) {
          this.availableReleases=[];
          this.AgrisVersion=null;
          this.selectedRelease=null;
        }
        this.getDataFromServer();
      });
      this.autoRefreshInterval = setInterval(() => {
        this.autoRefreshAgent();
      }, 1 * 1000);
    },
    autoRefreshAgent() {
      dataService.getAgent(this.editedItem.AgentId).then((newItem) => {
        this.editedItem=newItem;
      });
    },
    AgrisVersionSelected(AgrisVersion) {
      this.AgrisVersion=AgrisVersion;
      this.AgentAutoUpdate(this.editedItem);
    },
    syncAgent(item) {
      if (!this.IsAccessRefreshAgent) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.actioninProgress = true;
      // item.AgentId
      dataService.syncAgent(item.AgentId).then(() => {
        this.getDataFromServer().then(() => {
          this.actioninProgress = false;
        });
      });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    closeDetails() {
      this.dialogDetails=false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    closeLogTypes() {
      this.dialogLogTypes = false;
      this.btnDisabled = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    CheckOnlineStatus() {
      if (!this.IsAccessCheckStausOL) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      this.actioninProgress = true;
      this.editedItem.IsOnline=undefined;
      dataService.CheckOnlineStatus(this.editedItem.AgentId).then((IsOnline) => {
        this.actioninProgress = false;
        this.editedItem.IsOnline=IsOnline;
      });
    },
    done() {
      this.actioninProgress = true;
      if (!this.$refs.agentForm.validate()) {
        this.actioninProgress = false;
        return;
      }
      this.editedItem.MonitorLink = JSON.stringify(this.editedItem.MonitorLinkJson);
      if (this.editedItem.AgentId) {
        dataService.updateAgent(this.editedItem).then((agentId) => {
          this.getDataFromServer().then(() => {
            this.actioninProgress = false;
            this.close();
          });
        });
      } else {
        dataService.createAgent(this.editedItem).then((agentId) => {
          this.getDataFromServer().then(() => {
            this.actioninProgress = false;
            this.close();
          });
        });
      }
    },
    openMonitor(link) {
      if (!this.IsAccessOpenMonitor) {
        this.showNotif({ color: 'error', message: 'You do not have permission' });
        return;
      }
      window.open(link, '_blank').focus();
    },
    formatDate2(value) {
      let formatedDate = value;
      if (formatedDate) {
        if (typeof formatedDate === 'string') {
          formatedDate = new Date(formatedDate);
        }
        const serverClientTimeZoneDiff = ((new Date().getTimezoneOffset() - (240)) / 60) * -1;
        formatedDate.setTime(formatedDate.getTime() + (serverClientTimeZoneDiff * 60 * 60 * 1000));
        return moment(String(formatedDate)).format('MMM Do YYYY');
      } return '';
    },
    getServerName(InfoJSON) {
      const componentserverPotValue=((((InfoJSON||{}).Agris||{}).Output||'').split('componentserver="')[1]||'').split('"')[0]||'';
      return componentserverPotValue;
    },
    formatDate(value) {
      const delta = Math.round((+new Date() - new Date(`${value}Z`)) / 1000);

      const minute = 60;
      const hour = minute * 60;
      const day = hour * 24;
      const week = day * 7;

      let fuzzy;

      if (delta < 30) {
        fuzzy = 'just now.';
      } else if (delta < minute) {
        fuzzy = `${delta} seconds ago.`;
      } else if (delta < 2 * minute) {
        fuzzy = 'a minute ago.';
      } else if (delta < hour) {
        fuzzy = `${Math.floor(delta / minute)} minutes ago.`;
      } else if (Math.floor(delta / hour) === 1) {
        fuzzy = '1 hour ago.';
      } else if (delta < day) {
        fuzzy = `${Math.floor(delta / hour)} hours ago.`;
      } else if (delta < day * 2) {
        fuzzy = 'yesterday';
      } else if (delta < day*31) {
        fuzzy = `${Math.trunc(delta/day)} days ago`;
      } else if (delta < day * 62) {
        fuzzy = 'a month ago';
      } else {
        fuzzy = `${Math.trunc(Math.trunc(delta/day)/30)} months ago`;
      }
      return fuzzy;
    },
    formatDate3(value) {
      return moment(new Date(`${value}Z`)).format('MMM Do YYYY');
    },
    loadLogTypes() {
      dataService.getConfigModules().then((resp) => {
        this.configModules = resp || [];
        if (this.configModules.length > 0) {
          this.logModule = this.configModules.find(x => x.ModuleName === 'Logs');
          this.intervalModule = this.configModules.find(x => x.ModuleName === 'AgentIntervalSettings');
          if (this.logModule && this.logModule.ModuleId > 0) {
            dataService.getConfigKeys(this.logModule.ModuleId).then((keys) => {
              this.configKeys = keys || [];
            });
            dataService.getModuleConfigs(this.logModule.ModuleId).then((configs) => {
              this.logConfigs = configs || [];
            });
          }
          if (this.intervalModule && this.intervalModule.ModuleId > 0) {
            dataService.getModuleConfigs(this.intervalModule.ModuleId).then((configs) => {
              this.intervalConfigs = configs || [];
              const aliveIntervalObj = this.intervalConfigs.find(i => i.ConfigurationKey === 'AgrisServiceAliveIntervalCheck');
              if (aliveIntervalObj) this.aliveIntervalKeyId = aliveIntervalObj.ConfigurationKeyId;
            });
          }
        }
      });
    },
    getDataFromServer() {
      return new Promise((resolve, reject) => {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        this.loading = true;
        dataService.getAgentList().then((_agents) => {
          const total = _agents.length;
          this.loading = false;
          if (this.editedItem) {
            if (this.editedItem.AgentId) {
              const newEditAgent=_agents.filter(f => f.AgentId===this.editedItem.AgentId)[0];
              this.editedItem=newEditAgent||Object.assign({}, this.defaultItem);
              if (newEditAgent) {
                this.editedIndex = -1;
              }
              this.editedItem.MonitorLinkJson = Object.assign({ Link_1: '', Link_2: '' }, JSON.parse(this.editedItem.MonitorLink));
            }
          }
          if (this.pagination.sortBy) {
            // eslint-disable-next-line
            _agents = _agents.sort((a, b) => {
              const sortA = a[sortBy];
              const sortB = b[sortBy];

              if (descending) {
                if (sortA < sortB) return 1;
                if (sortA > sortB) return -1;
                return 0;
              }
              if (sortA < sortB) return -1;
              if (sortA > sortB) return 1;
              return 0;
            });
          }
          this.agents = _agents;

          console.log(_agents);
          setTimeout(() => {
            this.loading = false;
            resolve({
              _agents,
              total,
            });
          }, 1000);
        });
      });
    },
  },
};
</script>

<style scoped>
.container {
  padding-top: 2px;
  padding-bottom: 2px;
}
.cell-font-size {
  font-size: 12px;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}
</style>
